<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12"  md="3">
                <v-card elevation="2" :loading="loading">
                    <v-card-title>{{ count }} FILTROS</v-card-title>
                    <v-card-actions>
                        <v-btn color="primary" @click="add()"><v-icon>mdi-account-box</v-icon> AÑADIR FILTRO</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card elevation="2">
                    <v-card-title>
                        <p>Figuras Filtradas</p>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            :items="list"
                            :headers="headers"
                            :loading="loading"
                            hide-default-footer
                        >
                            <!-- eslint-disable-next-line -->
                            <template v-slot:item.is_active="{ item }">
                                <div>
                                    <v-chip v-if="!item.is_active" color="error" small>Inactivo</v-chip>
                                </div>
                            </template>
                            <!-- eslint-disable-next-line -->
                            <template v-slot:item.actions="{ item }">
                                <div>
                                    <v-btn v-if="item.is_active" icon @click="desbloquear(item)">
                                        <v-icon>mdi-shield-alert-outline</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card> 
            </v-col>
        </v-row>
        <BloqueoModal :open.sync="isModalOpen" :saved.sync="isSaved"/>
    </v-container>
    </template>
<script>
    //import UserList from '@components/entities/usuario';
    import BloqueoService from '@services/operadora-loteria/BloqueoFiguraService';
    import BloqueoModal from '@components/entities/operadora-loteria/bloqueo-figura/modal';

    export default {
        components: {
            //UserList,
            BloqueoModal
        },
        props: {
        
        },
        data: function() {
            return {
                headers: [
                    { text: 'Juego', align: 'start', value: 'juego.name' },
                    { text: 'Numero', value: 'numero' },
                    { text: 'Sorteo', value: 'juego_sorteo.horario' },
                    { text: 'Divisa', value: 'divisa.name' },
                    { text: 'Observación', value: 'is_active', width: 100},
                    { text: 'Acciones', value: 'actions', align: 'right', width: 150 },
                ],
                loading: false,
                list: [],
                count: 0,
                isModalOpen: false,
                isSaved: false,
                item: null,
            }
        },
        created: function () {
            this.$store.dispatch('ui/layout/setTitle', 'Filtrado de Figuras');
            this.getBloqueos();
        },
        methods:{
            add: function () {
                this.item = null;
                this.isModalOpen = true;
            },
            desbloquear: function (item) {
                this.$ui.confirm({
                    message: `Eliminar el filtro del ${item?.numero} Sorteo ${item?.juego_sorteo.horario}`,
                    textConfirm: 'Desbloquear',
                    textCancel: 'Cancelar',
                    confirm: () => {
                        BloqueoService.delete(item.id).then(() => {
                            this.$ui.notificate({message: 'Filtro eliminado'});
                        })
                        .catch(() => this.$ui.notificate({message: 'Error', color: 'error'}))
                        .finally(() => this.getBloqueos());
                    },
                });
            },
            getBloqueos: function(){
                this.loading = true;
                this.list = [];
                BloqueoService
                    .getList({is_active: true, fecha: this.$luxon.local().toISODate()})
                    .then(({ bloqueoFiguraList }) => {
                        this.list = bloqueoFiguraList;
                        this.count = this.list.length;
                    })
                    .finally(() => this.loading = false);
            }
        },
        watch: {
            isSaved: function (saved) {
                if (saved) this.getBloqueos();
            }
        }
    }
</script>
<tyle>

</tyle>